import { useMemo } from "react";
import { CHART_COLORS } from "@/components/analytics/ChartCanvas";
import { SERVICE_TREND_SERIES, type ServiceTrendPoint } from "../services.constants";
import { formatBucketLabel } from "../services.formatters";

export function useServiceTrendChartConfig(trend: ServiceTrendPoint[]) {
  return useMemo(
    () => ({
      type: "line" as const,
      data: {
        labels: trend.map((point) => formatBucketLabel(point.bucket)),
        datasets: SERVICE_TREND_SERIES.map((series) => ({
          label: series.label,
          data: trend.map((point) => point[series.key]),
          borderColor: series.color,
          tension: 0.3,
        })),
      },
      options: {
        plugins: {
          legend: { position: "top" as const, labels: { font: { size: 10.5 }, boxWidth: 10 } },
        },
        scales: {
          x: {
            ticks: { font: { size: 11 }, color: CHART_COLORS.muted },
            grid: { display: false },
          },
          y: {
            ticks: { font: { size: 11 }, color: CHART_COLORS.muted },
            grid: { color: CHART_COLORS.grid },
            beginAtZero: true,
          },
        },
      },
    }),
    [trend],
  );
}
